<style scoped>
.license-gate {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 60vh;
	padding: 2rem;
	text-align: center;
	color: #495057;
}
.license-gate-icon {
	font-size: 3rem;
	color: #adb5bd;
	margin-bottom: 1rem;
}
.license-gate-title {
	font-size: 1.25rem;
	font-weight: 600;
	margin-bottom: 0.5rem;
}
.license-gate-body {
	max-width: 30rem;
	margin: 0;
}
</style>

<template>
	<slot v-if="hasLicense" />
	<div v-else class="license-gate">
		<div class="license-gate-icon">
			<i class="bi bi-lock-fill"></i>
		</div>
		<h2 class="license-gate-title">
			This feature isn't included in your current license
		</h2>
		<p class="license-gate-body">
			Your organization's license doesn't include these features. If you'd
			like a demo or want to talk to sales about getting a license, reach
			out to
			<a href="mailto:sales@gleipnir.technology">sales@gleipnir.technology</a>.
		</p>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useSessionStore } from "@/store/session";

// The product (e.g. "reveal" or "core") required to render the wrapped
// content. When omitted, the gate is a no-op and always renders its slot.
const props = defineProps<{
	license?: string;
}>();

const session = useSessionStore();

const hasLicense = computed(() => {
	if (!props.license) return true;
	return session.organization?.licenses?.includes(props.license) ?? false;
});
</script>
